import { Box } from "@mui/material";
import { useState } from "react";
import CustomChip from "../../Components/CustomChip";
import { AddAdminStaffForm } from "./Components/AddAdminStaffForm";
import { EMPLOYEE_TYPES_ENUM } from "./Enum";
import { AddOwnerForm } from "./Components/AddOwnerForm";


export const AddEmployeeModal = ({
  firmID,
  onClose,
  defaultRole = {},
  allowedRoles,
  fetchEmployeeDetails,
  setShowStaffPermissionModal,
  onStaffOtpVerified,
}) => {
  const initialRole = allowedRoles && allowedRoles.length === 1 ? allowedRoles[0] : defaultRole;
  const [selectedRole, setSelectedRole] = useState(initialRole);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        {allowedRoles.map((role) => {
          return (
            <CustomChip
              key={role.value}
              label={role.label}
              onClick={() => setSelectedRole(role)}
              onDelete={
                selectedRole.value === role.value
                  ? () => setSelectedRole({})
                  : undefined
              }
              selected={selectedRole.value === role.value}
              variant={
                selectedRole.value === role.value ? "filled" : "outlined"
              }
            />
          );
        })}
      </Box>
      {selectedRole && (
        <Box>
          {(selectedRole.value === EMPLOYEE_TYPES_ENUM.ADMIN ||
            selectedRole.value === EMPLOYEE_TYPES_ENUM.STAFF) && (
            <AddAdminStaffForm
              selectedRole={selectedRole}
              firmId={firmID}
              onClose={onClose}
              fetchEmployeeDetails={fetchEmployeeDetails}
              setShowStaffPermissionModal={setShowStaffPermissionModal}
              onStaffOtpVerified={onStaffOtpVerified}
            />
          )}
          {selectedRole.value === EMPLOYEE_TYPES_ENUM.OWNER && (
            <AddOwnerForm
              selectedRole={selectedRole}
              firmId={firmID}
              onClose={onClose}
              fetchEmployeeDetails={fetchEmployeeDetails}
            />
          )}
        </Box>
      )}
    </Box>
  );
};
